<template>
  <!-- eslint-disable -->
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 1000 1000">
    <g>
      <path
        :fill="fill"
        fill-rule="nonzero"
        d="M745,430c58,0,105-47,105-105s-47-105-105-105s-105,47-105,105S687,430,745,430z"
      />
      <path
        :fill="fill"
        fill-rule="nonzero"
        d="M928.8,80H71.3C37.1,80,10,107.8,10,141.9v716.2c0,34.1,27.1,61.9,61.3,61.9h857.5c34.1,0,61.3-27.8,61.3-61.9V141.9C990,107.8,962.9,80,928.8,80z M703.2,512.5c-6.6-7.7-16.6-13.6-28-13.6c-11.2,0-19,5.3-28,12.5l-40.9,34.6c-8.5,6.1-15.3,10.3-25.2,10.3c-9.4,0-17.9-3.5-24.1-9c-2.2-2-6.1-5.7-9.4-9L430,411c-8.8-10.1-21.9-16.4-36.5-16.4s-28.2,7.2-36.8,17.1L80,745.4V175.6c2.2-14.9,13.8-25.6,28.7-25.6h782.5c15.1,0,27.3,11.2,28.2,26.3l0.7,569.6L703.2,512.5z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    fill: {
      default: '#94979B',
      type: String,
    },
  },
};
</script>
